import React from 'react';
import { Mail, Globe, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="py-8 px-4 bg-slate-900 text-white" data-id="element-87">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-88">
        <div className="mb-8" data-id="element-89">
          <span className="text-blue-400 font-black tracking-widest text-sm uppercase" data-id="element-90">
            GUIADIGITAL360 TM
          </span>
          <p className="text-slate-400 text-xs mt-2 font-bold uppercase tracking-tighter" data-id="element-91">
            Física en Acción © {new Date().getFullYear()}
          </p>
        </div>

        <div className="flex gap-6 mb-8" data-id="element-92">
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-93">
            <Instagram size={20} data-id="element-94" />
          </a>
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-95">
            <Mail size={20} data-id="element-96" />
          </a>
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-97">
            <Globe size={20} data-id="element-98" />
          </a>
        </div>

        <div className="space-y-2 text-[10px] md:text-xs text-slate-500 font-medium max-w-md" data-id="element-99">
          <p data-id="element-100">
            Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera.
          </p>
          <p data-id="element-101">
            Descargo de responsabilidad: Los resultados pueden variar de persona
            a persona. El material es de carácter pedagógico y didáctico.
          </p>
        </div>
      </div>
    </footer>;
}